import { EntityRepository, Repository } from "typeorm";
import { Rack } from "../racks.entity";

@EntityRepository(Rack)
export class RackRepository extends Repository<Rack>{
}